"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const experimentEnvironmentEnum = {
  PRODUCTION: 1,
  ENGPROD: 2,
  ENGNEW: 3,
  DEVELOPMENT: 4
};
var _default = experimentEnvironmentEnum;
exports.default = _default;